import { isUsMarket } from "utils/market";

export interface MedicationTranslation {
  locale: string;
  name: string;
  description: string | null;
  image_url?: string | null;
}

export interface VariantTranslation {
  locale: string;
  label: string;
}

export interface MedicationVariant {
  id: number;
  translations: VariantTranslation[];
}

export interface Medication {
  id: number;
  image_url: string | null;
  semantic_key: string | null;
  substance_id?: number | null;
  translations: MedicationTranslation[];
  variants: MedicationVariant[];
  patient_count: number;
}

export interface MedicationSubstance {
  id: number;
  semantic_key: string;
}

export interface UpsertVariantTranslation {
  locale: string;
  label: string;
}

export interface UpsertVariant {
  id?: number;
  translations: UpsertVariantTranslation[];
}

export interface UpsertTranslation {
  locale: string;
  name: string;
  description?: string;
  image_url?: string;
}

export interface UpsertMedicationRequest {
  image_url: string;
  semantic_key?: string | null;
  substance_id?: number | null;
  translations: UpsertTranslation[];
  variants: UpsertVariant[];
}

const EU_LOCALES = ["en-GB", "en-SE", "sv-SE"] as const;
const US_LOCALES = ["en-US", "es-US"] as const;
export const SUPPORTED_LOCALES = isUsMarket ? US_LOCALES : EU_LOCALES;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
/** Returns the en locale name from a medication's translation list, or first available. */
export function getMedicationName(m: Medication): string {
  const enUs = m.translations.find(t => t.locale === "en-US");
  if (enUs) return enUs.name;
  const en = m.translations.find(t => t.locale.startsWith("en"));
  if (en) return en.name;
  return m.translations[0]?.name ?? `Medication #${m.id}`;
}
